// useTreeSetting.js
import { computed, ref } from 'vue';
import _ from 'lodash';
import axios from 'axios';
async function getFromServer(array) {
    var data = await axios.post("api/cache/setting", { strings: array }).then((response) => {
        return response.data.data;
    })
    var stored = localStorage.getItem("settings.cache");
    var cache = JSON.parse(stored ?? '{}');
    _.merge(cache, data);
    localStorage.setItem("settings.cache", JSON.stringify(cache));
    return cache;
}
async function getAsync(string) {
    return await getFromServer([string]).then((response) => {
        return _.get(response, string);
    });
}

export async function buildCache(array) {
    return new Promise(async (resolve) => {
        var stored = localStorage.getItem("settings.cache");
        var cache = JSON.parse(stored ?? '{}');
        for (let i in array) {
            if (!_.has(cache, array[i])) {
                getFromServer(array).then(() => {
                    resolve();
                })
                return;
            }
        }
        resolve();
    })
}

export async function value_or_setting(value, string) {
    return new Promise((resolve) => {
        if (value) {
            resolve(value);
            return;
        } else {
            return getAsync(string).then((response) => {
                resolve(response)
            });
        }
    })
}

export function cacheValid(){
    let valid_since = localStorage.getItem("cache_valid_since") ?? "";
    if(window.cache_valid_since == valid_since && valid_since != "") {
        return;
    }
    cacheClear();
    localStorage.setItem("cache_valid_since", window.cache_valid_since);
}

export async function get_setting(string) {
    cacheValid();
    var stored = localStorage.getItem("settings.cache");
    var cache = JSON.parse(stored ?? '{}');
    return new Promise((value, reject) => {
        let tmp = _.get(cache, string);
        if (tmp !== undefined) {
            value(tmp);
            return;
        }
        getAsync(string).then((response) => {
            value(response)
        }).catch(() => {
            reject();
        })
    });
}


export function sync_get_setting(string) {
    cacheValid();
    var stored = localStorage.getItem("settings.cache");
    var cache = JSON.parse(stored ?? '{}');
        let tmp = _.get(cache, string);
        if (tmp !== undefined) {
            return tmp;
        }
        getAsync(string).then((response) => {
            return response;
        }).catch(() => {

        });
}

export async function getSetting(string) {
    var stored = localStorage.getItem("settings.cache");
    var cache = JSON.parse(stored ?? '{}');
    return new Promise((value, reject) => {
        let tmp = _.get(cache, string);
        if (tmp != undefined) {
            value(tmp);
            return;
        }
        getAsync(string).then((response) => {
            value(response)
        }).catch(error => {
            reject();
        });
    });
}
export function cacheClear(string = "") {
    var stored = localStorage.getItem("settings.cache");
    var cache = JSON.parse(stored ?? '{}');
    if (string != "") {
        _.unset(cache, "" + string);
    } else {
        cache = {};
    }

    localStorage.setItem("settings.cache", JSON.stringify(cache));
}
export async function serverCacheClear(string = "") {
    cacheClear(string);
    var data = {};
    if (string != "") {
        data.string = string;
    }
    return axios.post("api/cache/clear", data);
}
